import { c as _c } from "react/compiler-runtime";
import React from 'react';
interface AQMarkProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
  style?: React.CSSProperties;
}
const AQMark = t0 => {
  const $ = _c(11);
  let className;
  let props;
  let style;
  if ($[0] !== t0) {
    ({
      className,
      style,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = style;
  } else {
    className = $[1];
    props = $[2];
    style = $[3];
  }
  let t1;
  let t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M30.1192 58.7999C46.0792 58.7999 58.9192 45.8399 58.9192 30C58.9192 14.16 45.9592 1.19995 30.1192 1.19995C14.2792 1.19995 1.19922 14.04 1.19922 30C1.19922 45.9599 14.1592 58.7999 30.1192 58.7999Z" fill="#f26649" />;
    t2 = <path d="M17.5205 19.9199L7.56055 40.4399H13.0805H19.3205V35.6399H15.3605L19.3205 27.4799L25.5605 40.4399H30.9605L21.0005 19.9199H17.5205Z" fill="#ffffff" />;
    t3 = <path d="M39.9604 35.6401C36.8404 35.6401 34.3204 33.1201 34.3204 30.0001C34.3204 26.8801 36.8404 24.3601 39.9604 24.3601C43.0804 24.3601 45.6004 26.8801 45.6004 30.0001C45.6004 33.1201 43.0804 35.6401 39.9604 35.6401ZM48.8404 35.6401C49.9204 33.9601 50.5204 32.0401 50.5204 30.0001C50.5204 24.2401 45.8404 19.5601 39.9604 19.5601C34.2004 19.5601 29.4004 24.2401 29.4004 30.0001C29.4004 35.7601 34.0804 40.4401 39.9604 40.4401C40.2004 40.4401 40.3204 40.4401 40.5604 40.4401H51.8404V35.6401H48.8404Z" fill="#ffffff" />;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
  }
  let t4;
  if ($[7] !== className || $[8] !== props || $[9] !== style) {
    t4 = <svg viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} style={style} {...props}>{t1}{t2}{t3}</svg>;
    $[7] = className;
    $[8] = props;
    $[9] = style;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
export default AQMark;